const MANAGE_WEBSITE = '/manage-website'
const BASE_STUDIO_URL = process.env.REACT_APP_STUDIO_BASE_URL as string

export const LINKS = {
  WEBSITE_ANALYTICS: (user: any, authToken: any) => `${String(user.account.websiteUrl)}/wp-admin/?email=${String(authToken?.login)}&token=${String(authToken?.token)}` /* 'https://agentelitewstg.agentelite.com/carolina-romero/wp-admin/admin.php?page=analytics' */,
  IHF: 'https://account.idxhome.com/login',
  IHF_DASHBOARD: (login: string, password: string) => `https://account.idxhome.com/login?username=${login}&password=${password}`,
  FACEBOOK: 'https://www.facebook.com/agenteliteinc/',
  LINKEDIN: 'https://www.linkedin.com/company/agent-elite',
  INSTAGRAM: 'https://www.instagram.com/agentelite/',
  TWITTER: 'https://twitter.com/agenteliteinc',
  YOUTUBE: 'https://www.youtube.com/channel/UC4Z9hT5Kx6Wgium-iRgxqzg',
  TERMS_AND_CONDITIONS: 'https://agentelite.com/terms-and-conditions/',
  PRIVACY_POLICY: 'https://agentelite.com/privacy-policy/',
  MANAGE_WEBSITE,
  VIEW_MY_WEBSITE: (user: any) => user?.account.websiteUrl ? `${String(user.account.websiteUrl)}` : MANAGE_WEBSITE,
  STUDIO_DASHBOARD: (token: string) => `${BASE_STUDIO_URL}/users/sign_in_with_auth_token?auth_token=${token}`
}
